module.exports = __webpack_public_path__ + "static/gatsby-logo-4a9773549091c227cd2eb82ccd9c5e3a.png";